import { ArrowRightIcon } from "@phosphor-icons/react";

import { Button } from "@alpacahq/ui/old";
import { DataGrid } from "@alpacahq/ui/old/datagrid";

import type { TransfersTableControllerReturn } from "./TransfersTable.controller";

export interface TransfersTablePresentationProps
  extends TransfersTableControllerReturn {}

export const TransfersTablePresentation = ({
  transfers,
}: TransfersTablePresentationProps) => (
  <section className="flex flex-col gap-4">
    <div className="flex items-center justify-between gap-4">
      <h2 className="m-0 p-0 font-semibold text-base text-gray-950">
        Recent Transfers
      </h2>
      {transfers.tableProps.rows.length > 0 && (
        <Button
          variant="v2/ghost"
          size="v2/base"
          onClick={transfers.onViewAllClicked}
          className="flex items-center gap-2 no-underline"
        >
          View All <ArrowRightIcon size={16} />
        </Button>
      )}
    </div>

    <DataGrid
      variant="modern"
      key="coin-transfers"
      isLoading={transfers.isLoading || transfers.tableProps.isLoading}
      rows={transfers.tableProps.rows}
      columns={transfers.tableProps.columns}
      emptyMessage="Your most recent transfers will show here."
    />
  </section>
);
